<template>
	<rr-text v-if="isSubmit"
	         :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_LARGE"
	         :text-color="$const.HTML_CLASS.TEXT_COLOR.TRANSPARENT_LIGHT" v-html="$t('form_send')"/>
	<form v-else @submit.prevent="validate">
		<rr-input ref="inputs" v-for="(inputOpts, index) in inputs" :key="index" v-bind="inputOpts"/>
		<rr-button ref="sb"
		           :text-type="$const.HTML_CLASS.TEXT_TYPE.TITLE_PRIMARY_LARGE"
		           :text-color="$const.HTML_CLASS.TEXT_COLOR.TRANSPARENT_LIGHT">
			{{ $t('input_send') }}&nbsp;<span v-html="require('!svg-inline-loader!@/assets/img/svg/link-arrow.svg')"/>
		</rr-button>
	</form>
</template>

<script>
export default {
	name: 'ContactForm',
	data() {
		return {
			// inputs
			inputs: [
				{
					inputId: 'yf-name',
					placeholderText: this.$t('input_name'),
					isRequired: true,
				},
				{
					inputId: 'yf-email',
					placeholderText: 'Email',
					pattern: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
					// patternErrorMessage: this.$t('incorrect_hint'),
					isRequired: true,
				},
				{
					inputId: 'yf-message',
					placeholderText: this.$t('input_msg'),
					isTextarea: true,
				},
			],
			// submit
			isSubmit: false,
		}
	},
	// props: {
	// 	textType: {
	// 		type: String,
	// 	},
	// },
	mounted() {
	},
	destroyed() {
	},
	methods: {
		validate() {
			let body = '',
				isValid = true;

			this.$refs['inputs'].forEach(input => {
				if (input.value === null) {
					input.value = ''
				}

				if (!input.isValid) {
					isValid = false
				} else {
					body += `&${input.inputId}=${input.value}`
				}
			})

			this.isSubmit = isValid

			if (isValid) {
					const xhr = new XMLHttpRequest()
					xhr.open('POST', '/send.php', true)
					xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded')
					xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')

					xhr.send(body) // (1)

					xhr.onreadystatechange = function () { // (3)
						if (xhr.readyState != 4) return

						// const statusMsg = (xhr.status != 200) ? '<span style="color: #ff0000;">Помилка при відправленні.</span>'
						// 	: 'Ваша заявка успішно відправлена! Дякуємо за участь у конкурсі.'
						//
						// showMessage(statusMsg)

						if (xhr.status != 200) {
							// eslint-disable-next-line
							console.log(xhr.status + ': ' + xhr.statusText)
						}
					}

					// (2)
					// showMessage('Відправляю...')
			}
		},
	},
	watch: {},
}
</script>

<style lang="scss">
// form
form {
	max-width: 100%;
	button {
		@include space-responsive-margin-t(289);
		// mobile
		@include breakpoint($mobileDesignBreakpoint) {
			margin-top: (42 + 42 + 73) * 1px;
		}
		// icon
		svg {
			height: .7em;
		}
	}
}
</style>
